const API_BASE = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_API_BASE_URL) || '/api/bravosim/v1'

function buildUrl(endpoint, query) {
  let url = `${API_BASE}${endpoint}`
  if (query && Object.keys(query).length) {
    const params = new URLSearchParams()
    Object.entries(query).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        // Para arrays, adiciona cada valor separadamente
        value.forEach(v => params.append(key, v))
      } else if (value !== null && value !== undefined) {
        params.append(key, value)
      }
    })
    const qs = params.toString()
    if (qs) url += (url.includes('?') ? '&' : '?') + qs
  }
  return url
}

async function request(method, endpoint, data = null, opts = {}) {
  const { signal, headers: extraHeaders, query } = opts || {}
  const headers = { ...(extraHeaders || {}) }

  // SEGURANÇA: Token agora em sessionStorage (após correções de segurança)
  // Fallback para localStorage para compatibilidade com sessões antigas
  const token = sessionStorage.getItem('bravo-tax-token') ||
                localStorage.getItem('bravo-tax-token') ||
                localStorage.getItem('access_token')
  let usedAuth = false
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
    usedAuth = true
  }

  const init = { method, headers, signal }

  if (data != null && method !== 'GET') {
    init.headers['Content-Type'] = 'application/json'
    init.body = JSON.stringify(data)
  }

  const url = buildUrl(endpoint, query)
  const response = await fetch(url, init)

  if (!response.ok) {
    // Se receber 401, disparar evento para logout automático
    if (response.status === 401) {
      window.dispatchEvent(new CustomEvent('auth:unauthorized'))
    }

    let message = `HTTP ${response.status}`
    let errorData = null
    try {
      errorData = await response.json()
      message = errorData?.detail || errorData?.message || message
    } catch { }

    const error = new Error(message)
    error.response = { status: response.status, data: errorData }
    throw error
  }

  if (response.status === 204) return null

  // Tenta JSON; se falhar, retorna texto
  const ct = response.headers.get('content-type') || ''
  if (ct.includes('application/json')) return response.json()
  return response.text()
}

export const apiGet = (endpoint, options) => request('GET', endpoint, null, options)
export const apiPost = (endpoint, data, options) => request('POST', endpoint, data, options)
export const apiPatch = (endpoint, data, options) => request('PATCH', endpoint, data, options)
export const apiDelete = (endpoint, options) => request('DELETE', endpoint, null, options)
